import { compose, lifecycle, withHandlers, withProps, withState } from 'recompose'
import { isEqual } from 'lodash'
import CreateAccountForm from './CreateAccountForm'
import { ALREADY_REGISTERED_EMAIL_ERROR_MESSAGE } from '../../constants'

const withShowReCaptchaState = withState('showReCaptcha', 'setShowReCaptcha', false)

const withFormProps = withProps(() => {
  const { BOT_GOOGLE_RECAPTCHA_SITE_KEY } = (window.GLOBAL_VARS || process.env)

  return {
    BOTGoogleReCaptchaSiteKey: BOT_GOOGLE_RECAPTCHA_SITE_KEY
  }
})

const withLifecycle = lifecycle({
  componentDidUpdate({ error: prevError }) {
    const {
      error,
      setShowReCaptcha,
      setIsReCaptchaVerified
    } = this.props

    if (!isEqual(error, prevError)
      && error
      && Array.isArray(error)
      && error[0] === ALREADY_REGISTERED_EMAIL_ERROR_MESSAGE) {
      setShowReCaptcha(true)
      setIsReCaptchaVerified(false, 'did update')
    }
  }
})

const withReCaptchaHandlers = withHandlers({
  reCaptchaOnChange: ({ setIsReCaptchaVerified, resetNotVerifiedReCaptchaMessage }) => () => {
    setIsReCaptchaVerified(true)
    resetNotVerifiedReCaptchaMessage()
  },
  reCaptchaOnExpired: ({ setIsReCaptchaVerified }) => () => {
    setIsReCaptchaVerified(false, 'on expired')
  }
})

export default compose(
  withShowReCaptchaState,
  withFormProps,
  withLifecycle,
  withReCaptchaHandlers
)(CreateAccountForm)
